const PapuaNewGuineaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112131)">
      <path
        d="M34.1422 34.1426C26.3317 41.9531 13.6685 41.9531 5.85784 34.1426C-1.95263 26.3321 -1.95263 13.6688 5.85792 5.85822C13.6684 -1.95225 25.1019 -0.722484 32.9124 7.08806C40.7228 14.8985 41.9526 26.3321 34.1422 34.1426Z"
        fill="black"
      />
      <path
        d="M5.85742 5.85778C13.6679 -1.95269 26.3311 -1.95253 34.1417 5.85786C41.9522 13.6683 41.9522 26.3316 34.1417 34.1422"
        fill="#A2001D"
      />
      <path
        d="M15.2851 26.957L15.6088 27.9535H16.6565L15.8089 28.5693L16.1327 29.5658L15.2851 28.9499L14.4374 29.5658L14.7612 28.5693L13.9136 27.9535H14.9612L15.2851 26.957Z"
        fill="#F0F0F0"
      />
      <path
        d="M12.609 17.3916L13.1488 19.0524H14.8949L13.4821 20.0787L14.0218 21.7395L12.609 20.713L11.1964 21.7395L11.7361 20.0787L10.3232 19.0524H12.0695L12.609 17.3916Z"
        fill="#F0F0F0"
      />
      <path
        d="M12.609 29.5654L13.1486 31.2262H14.8949L13.482 32.2525L14.0218 33.9132L12.609 32.8868L11.1964 33.9132L11.7359 32.2525L10.3232 31.2262H12.0693L12.609 29.5654Z"
        fill="#F0F0F0"
      />
      <path
        d="M17.7144 21.7402L18.2542 23.401H20.0003L18.5875 24.4273L19.1271 26.088L17.7144 25.0616L16.3018 26.088L16.8414 24.4273L15.4287 23.401H17.1749L17.7144 21.7402Z"
        fill="#F0F0F0"
      />
      <path
        d="M7.50307 21.7402L8.04283 23.401H9.78885L8.37619 24.4273L8.91572 26.088L7.50307 25.0616L6.09033 26.088L6.6301 24.4273L5.21729 23.401H6.96346L7.50307 21.7402Z"
        fill="#F0F0F0"
      />
      <path
        d="M33.4803 14.8093C32.5865 13.9154 31.4251 13.3874 30.177 13.2967L33.9129 10.391C32.4251 8.90309 30.4308 8.23113 28.4849 8.37324C28.2519 7.53605 27.8078 6.74527 27.1494 6.08691L25.6737 9.03832C25.5769 8.86191 25.4544 8.6959 25.3048 8.54645C24.4558 7.69746 23.0794 7.69746 22.2304 8.54645C21.3815 9.39543 21.3814 10.7718 22.2304 11.6208C22.3799 11.7703 22.546 11.8929 22.7224 11.9897L19.771 13.4654C20.4295 14.124 21.2208 14.5685 22.0585 14.8013C21.9159 16.7472 22.5872 18.7411 24.0751 20.2291L27.3392 16.0324C27.5847 15.7906 27.909 15.6571 28.254 15.6571C28.6025 15.6571 28.93 15.7927 29.1763 16.0392C29.4227 16.2855 29.5584 16.6131 29.5584 16.9614C29.5584 17.3099 29.4227 17.6374 29.1763 17.8838L30.4062 19.1136C30.9809 18.5388 31.2976 17.7745 31.2976 16.9615C31.2976 16.2964 31.0854 15.664 30.6937 15.1412C31.2644 15.2936 31.8039 15.5922 32.2508 16.0392C33.607 17.3954 33.607 19.6021 32.2508 20.9582L33.4806 22.188C34.466 21.2025 35.0087 19.8924 35.0087 18.4987C35.0085 17.1049 34.4657 15.7947 33.4803 14.8093Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112131">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default PapuaNewGuineaSvg;
